module.exports = __webpack_public_path__ + "static/media/YF03_5.cb6c9aa5.jpg";